export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const updateUserFailure = error => ({
    type: UPDATE_USER_FAILURE,
    payload: error,
    error: true,
});
